/**
 * Toast position
 */
export class SnotifyPosition {
  static leftTop = 'leftTop';
  static leftCenter = 'leftCenter';
  static leftBottom = 'leftBottom';

  static rightTop = 'rightTop';
  static rightCenter = 'rightCenter';
  static rightBottom = 'rightBottom';

  static centerTop = 'centerTop';
  static centerCenter = 'centerCenter';
  static centerBottom = 'centerBottom';
}
